export default __webpack_public_path__ + "static/media/next-black.9ad8f097.svg";